import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import {
  Typography,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  IconButton,
  Button,
  DialogContent,
  DialogContentText,
  DialogActions,
  CardMedia,
} from "@mui/material";
import SubmitButton from "./SubmitButton";
import { toMoney } from "../../util/Utils";
import { UseOrders } from "../OrdersPage/UseOrders";
import totalCostIcone from "../../images/icon/totalCost.png";
import discountIcone from "../../images/icon/tag.png";
import discountCodetIcone from "../../images/icon/coupon.png";
import totalPaymentIcone from "../../images/icon/totalPayment.png";
import deliveryCostIcone from "../../images/icon/deliveryCost.png";
import paymentTypeIcone from "../../images/icon/paymentType.png";
import BankCodetIcone from "../../images/icon/BankCode.png";
import { useNavigate, useLocation } from "react-router-dom";
import UserWalletDetails from "../userswallet/UserWalletDetails";
import useBreakpoints from "../../hooks/useBreakpoints";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function OrderPayMent(props) {
  const { CancelInstallmentOrder, UpdateOrderFinancial } = UseOrders();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [openDetail, setOpenDetail] = useState({
    show: false,
    mobile: undefined,
  });
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openInf, setOpenInf] = useState({
    show: false,
  });
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    paymentBankSerial: "",
  });
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  useEffect(() => {
    if (openInf.show == true) {
      setState({
        paymentBankSerial: props.orderDetail.paymentBankSerial,
      });
    }
  }, [openInf]);

  return (
    <Box>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            با عدم تایید حسابرسی سفارش فوق کنسل میشود
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              var body = {
                OrderId: props.orderDetail.id,
                FinancialID: 3,
              };
              UpdateOrderFinancial(body, (call) => {
                navigate(
                  `/orders?state=${
                    location.state ? location.state.orderState : 1
                  }`,
                  {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  }
                );
                setOpenConfirm(false);
              });
            }}
          >
            تایید
          </Button>
          <Button color="error" onClick={() => setOpenConfirm(false)}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setOpenInf({
            show: false,
          });
          setState({
            paymentBankSerial: "",
          });
        }}
        open={openInf.show}
      >
        <DialogTitle>ویرایش شناسه پرداخت بانکی</DialogTitle>
        <Box
          sx={{
            mx: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <TextField
            fullWidth
            autoFocus
            value={state.paymentBankSerial ? state.paymentBankSerial : ""}
            label="شناسه پرداخت بانکی"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({
                ...state,
                paymentBankSerial: evt.target.value,
              });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <SubmitButton
              Value={state.paymentBankSerial}
              FiledName="OfflinePaymentRef"
              id={props.orderDetail.id}
              callback={() => {
                props.setOrderDetail({
                  ...props.orderDetail,
                  paymentBankSerial: state.paymentBankSerial,
                });
                setOpenInf({ ...openInf, show: false });
              }}
            />
            <Button
              sx={{ ml: 1 }}
              color="error"
              variant="outlined"
              onClick={() => setOpenInf({ ...openInf, show: false })}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Dialog>
      <Box sx={{ p: 2, mb: 2 }}>
        <Typography sx={{ mb: 2 }} color="secondary" variant="h6">
          اطلاعات مالی
        </Typography>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={totalCostIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                جمع خرید
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.totalCost
                  ? toMoney(props.orderDetail.totalCost)
                  : 0}
              </Typography>
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={discountIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                تخفیف مستقیم
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.directDiscount
                  ? toMoney(props.orderDetail.directDiscount)
                  : 0}
              </Typography>
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={discountIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                تخفیف اعتباری
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.creditDiscount
                  ? toMoney(props.orderDetail.creditDiscount)
                  : 0}
              </Typography>
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={discountCodetIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                کد تخفیف
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.discountCode
                  ? props.orderDetail.discountCode
                  : "-"}
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={discountCodetIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                تخفیف
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.discountCodeCost
                  ? toMoney(props.orderDetail.discountCodeCost)
                  : 0}
              </Typography>
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 4"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={deliveryCostIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                هزینه ارسال
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.deliveryCost
                  ? toMoney(props.orderDetail.deliveryCost)
                  : 0}
              </Typography>
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={totalPaymentIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                مبلغ قابل پرداخت
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.totalPayment
                  ? toMoney(props.orderDetail.totalPayment)
                  : 0}
              </Typography>
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={paymentTypeIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                نوع پرداخت
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.payment}
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={BankCodetIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                شناسه پرداخت بانکی
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 2,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.paymentBankSerial}
              </Typography>
              <IconButton
                onClick={() =>
                  setOpenInf({
                    show: true,
                  })
                }
                sx={{ p: 0 }}
              >
                <EditIcon fontSize="small" color="secondary" />
              </IconButton>
            </Box>
            <Box sx={{ ml: 1 }}>
              {props.orderDetail.cancelInstallmentOrder && (
                <Button
                  size="small"
                  onClick={() =>
                    setCheckState({
                      show: true,
                      name: "لغو سفارش اقساطی",
                    })
                  }
                  color="secondary"
                  variant="contained"
                >
                  لغو سفارش اقساطی
                </Button>
              )}
              {props.orderDetail.stateID == 6 && (
                <Box>
                  <Button
                    onClick={() => {
                      var body = {
                        OrderId: props.orderDetail.id,
                        FinancialID: 2,
                      };
                      UpdateOrderFinancial(body, (call) => {});
                    }}
                    sx={{ mr: 1 }}
                    color="secondary"
                    size="small"
                    variant="contained"
                  >
                    تایید
                  </Button>
                  <Button
                    size="small"
                    onClick={() => setOpenConfirm(true)}
                    color="secondary"
                    variant="outlined"
                  >
                    عدم تایید
                  </Button>
                </Box>
              )}
              {(props.orderDetail.stateID == 1 ||
                props.orderDetail.stateID == 0) && (
                <Button
                  onClick={() => {
                    var body = {
                      OrderId: props.orderDetail.id,
                      FinancialID: 1,
                    };
                    UpdateOrderFinancial(body, (call) => {});
                  }}
                  size="small"
                  color="secondary"
                  variant="contained"
                >
                  ارسال به حسابرسی
                </Button>
              )}
            </Box>
          </Box>
          <Box
            gridColumn={isSmall ? "span 12" : "span 4"}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <Box
              sx={{
                width: "180px",
                bgcolor: "#EFF2F7",
                border: "1px solid #d5dde6",
                py: 1,
                mr: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardMedia
                sx={{ width: "20px", ml: 1 }}
                component="img"
                alt="green iguana"
                image={deliveryCostIcone}
              />
              <Typography sx={{ ml: 1, color: "#3e485c" }} variant="subtitle2">
                هزینه ارسال پست
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#f9fafc",
                border: "1px solid #d5dde6",
                py: 1,
                px: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: "right",
                  color: "#3e485c",
                }}
                variant="subtitle2"
              >
                {props.orderDetail.postDeliveryCost
                  ? toMoney(props.orderDetail.postDeliveryCost)
                  : 0}
              </Typography>
            </Box>
          </Box>
          <Box gridColumn="span 12">
            <Button
              variant="contained"
              onClick={() =>
                setOpenDetail({
                  show: true,
                  mobile: props.orderDetail?.mobile,
                })
              }
            >
              افزودن به کیف پول
            </Button>
          </Box>
        </Box>
      </Box>
      {openDetail.show && (
        <UserWalletDetails
          openDetail={openDetail}
          setOpenDetail={setOpenDetail}
          callback={() => {}}
        />
      )}
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          setProgress(true);
          CancelInstallmentOrder(props.orderDetail.id, () => {
            // navigate(
            //   `/orders?state=${location.state ? location.state.orderState : 1}`,
            //   {
            //     state: { ...location.state, isBack: true },
            //     replace: true,
            //   }
            // );
          });
        }}
      />
    </Box>
  );
}
